// Shared by `lib/api/web_route.ts` (server) and `lib/web_api/fetch_web_api.ts` (browser).

/** Marks a repeated search param, so a single value still parses as an array. */
export const WEB_QUERY_ARRAY_SUFFIX = '[]';

/** The company the browser tab is showing. Company routes reject a read for any other company. */
export const WEB_API_COMPANY_HEADER = 'X-Much-Company-Id';

/** The metadata of a file response, whose body is the file content itself. */
export const WEB_FILE_META_HEADER = 'X-Web-File-Meta';

export const COMPANY_CHANGED_CODE = 'company_changed';
